<template>
	<div>
		<j-card class="mb2">
			<j-accordion colorWhenClosed="bg0">
				<div slot="title" class="fs4 fw7">{{ $t("benefit_options") }}</div>
				<!-- List of Benefit Options -->
				<data-list
					label="Options"
					slot="body"
					:list="list"
					@item:remove="$emit('option:remove', $event)"
					@item:update="$emit('option:update', $event)"
				>
					<j-button
						v-if="showButtons"
						type="tertiary"
						size="small"
						slot="label"
						@click="$emit('benefit_option:open_modal')"
						>+ Add</j-button
					>
				</data-list>
			</j-accordion>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JAccordion from "@/components/JAccordion"
import JButton from "@/components/JButton"
import DataList from "../../DataList"

export default {
	components: { JCard, JAccordion, DataList, JButton },

	props: {
		showTitle: {
			type: Boolean,
			required: false,
			default: true
		},
		showButtons: {
			type: Boolean,
			required: false,
			default: false
		},
		list: {
			type: Array,
			required: false,
			default: () => []
		},
		benefitOptions: Array
	},

	data() {
		return {
			isLoading: false
		}
	}
}
</script>
